const normalizeEmail = (email: string) => email.trim().toLowerCase();

export default normalizeEmail;
